import React, { useState, useRef, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { workspaceCreateRequest } from '../../redux/workspace/workspace.actions';

import Logo2 from '../../components/Logo/Logo2';
import OnboardingUserMenu from './OnboardingUserMenu';
import LoaderSimple from '../../components/Loaders/LoaderSimple/LoaderSimple';

import './WorkspaceOnboarding.scss';

export const WorkspaceOnboarding = () => {
    const dispatch = useDispatch();
    const history = useHistory();

    document.title = 'DB Design';

    const [name, setName] = useState('My Workspace');
    const [loading, setLoading] = useState(false);

    const inputRef = useRef(null);

    useEffect(() => {
        document.title = 'DB Design';
    }, []);

    // Focus the name input on mount and whenever loading clears (e.g. after an
    // error). Keyed on `loading` so it runs AFTER the input re-enables —
    // focusing a still-disabled input would be a no-op.
    useEffect(() => {
        if (!loading && inputRef.current) inputRef.current.focus();
    }, [loading]);

    const handleCreate = () => {
        if (loading || !name.trim()) return;
        setLoading(true);
        dispatch(workspaceCreateRequest({
            title: name.trim(),
            email: '',
            // Success: the saga refetches the list, App.js swaps to <Dashboard />
            // and this page unmounts. loading stays true so the button keeps the
            // loader until unmount; onSuccess does no setState (no unmount warning).
            onSuccess: () => history.replace('/diagrams/'),
            // Error (plan_limit / auth / validation / generic — saga owns the
            // follow-up UX): stop loading and return focus to the input.
            onError: () => setLoading(false),
        }));
    };

    return (
        <div className="workspace-onboarding">
            <Logo2 isLand={true} />
            <OnboardingUserMenu />

            <div className="wo-inner">
                <div className="wo-hero">
                    <h1 className="wo-title">Create a workspace</h1>
                    <p className="wo-subtitle">Organize database design and team collaboration</p>
                </div>

                <div className="wo-content">
                    <div className="wo-card">
                        <div className="wo-field">
                            <label className="wo-label" htmlFor="wo-workspace-name">Workspace name</label>
                            <input
                                id="wo-workspace-name"
                                ref={inputRef}
                                type="text"
                                maxLength="1000"
                                autoComplete="off"
                                spellCheck="false"
                                placeholder="Enter workspace name"
                                value={name}
                                disabled={loading}
                                onChange={(e) => setName(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        e.preventDefault();
                                        handleCreate();
                                    }
                                }}
                            />
                        </div>
                        <button
                            className="wo-submit"
                            onClick={handleCreate}
                            disabled={loading || !name.trim()}
                        >{loading ? <LoaderSimple /> : 'Create workspace'}</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WorkspaceOnboarding;
